import React from 'react';
// import '../../_assets/css/file.css';
import { Form } from "react-bootstrap";
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { AGENTEMAIL, AGENTID, AGENTNAME, AGENTPHONE, TOKEN } from '../../_helpers/exports';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Input from 'react-phone-number-input/input'
import { Link } from 'react-router-dom';
import Alert from '../../shared/components/Alert';
import agentdetails from './agentdetails';
import Select from 'react-select';


class ModifyAgent extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props)
        this.state = {
            showComponent: false,
            hideComponent: true,
            moreinfo: false,
        };
        this._onButtonClick = this._onButtonClick.bind(this);
        this._onMoreInfo = this._onMoreInfo.bind(this);

        this.changeStatus = this.changeStatus.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            isLoading: false,
            isShowError: false,
            statusMessage: '',
            showError: false
        }
    }

    handleChangeRegion = (event) => {
        this.setState({ customer_type: event.target.value });
    };


    handleChangeType = (event) => {
        this.setState({ title: event.target.value });
    };

    onSubmit(e) {
        e.preventDefault();


        let formData = {
            "agent_id": AGENTID,
            "name": AGENTNAME,
            "msisdn": AGENTPHONE,
            "email": AGENTEMAIL,
            "bank_code": this.state.bank_code,
            "bank_account_no": this.state.bank_account_no,
            "session_id": TOKEN
        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'modify_agent_details', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this._onButtonClick();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }


    _onButtonClick() {
        this.setState({
            showComponent: true,
            hideComponent: true,
            moreinfo: false
        });
    }

    _onMoreInfo() {
        this.setState({
            showComponent: false,
            hideComponent: true,
            moreinfo: true
        });
    }

    changeStatus() {
        this.setState({
            isShowError: false
        });
    }

    componentDidMount() {

        // alert(JSON.stringify(AGENTID, AGENTEMAIL, AGENTPHONE, AGENTNAME))

        let axiosConfig = {
            headers: {
                "Authorization": TOKEN
            }
        };

        this.setState({
            isLoading: true
        })
        let url = baseURL + "banks"
        console.log("query", url);
        axios.all([
            axios.get(url, axiosConfig),
        ]).then(axios.spread((bankResponse) => {
            this.setState({
                Bank: bankResponse.data.banks,
                isLoading: false,
            })
        })).catch(error => {
        })
    }

    Banks() {
        return (
            this.state.Bank &&
            (this.state.Bank.length > 0 || this.state.Bank.length === 0) &&
            this.state.Bank.map((countyItem, i) => ({
                label: countyItem.name,
                bank: countyItem.name,
                value: countyItem.code,
            }))
        );
    }
    onSelectChangesBank = value => {
        if (value != null) {

            this.setState(
                {
                    bank_code: value.value.toString(),
                    bank_name: value.label.toString()
                });
        }
    };


    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent } = this.state;

        return (
            <div>
                {showComponent && (
                    <div>
                        {this.state.showComponent ?
                            <agentdetails /> : null
                        }
                    </div>
                )}
                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4><b>Modify Agent Detail</b></h4><br />
                                        </div>
                                        <div className="col-md-6">
                                            <Link to="profile">
                                                <Button className="float-right" outline color="primary" onClick={this._onButtonClick}>
                                                    <i className="fa  fa-arrow-left"></i> Back</Button>
                                            </Link>
                                        </div>
                                    </div>


                                    {this.state.showError ? <div >

                                        <Alert color="danger" className="alert--colored" icon>
                                            <p><span className="bold-text">{this.state.statusMessage}</span>
                                            </p>
                                        </Alert>


                                    </div> : null}<br></br>

                                    {this.state.isShowError ? (
                                        <div>

                                            <Alert color="success" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>
                                        </div>
                                    ) : null}<br></br>
                                    <form className="form" className="col-8 offset-2" onSubmit={this.onSubmit}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <label className="form-label">Banks</label>
                                                    </div>
                                                    <div className="col-md-10">

                                                        <Select
                                                            isClearable
                                                            options={this.Banks()}
                                                            // onInputChange={this.loadOptions}
                                                            placeholder="Search Bank"
                                                            autosize={true}
                                                            onChange={this.onSelectChangesBank}
                                                            isLoading={this.state.isLoading}
                                                            // noOptionsMessage={() => 'nothing found'}
                                                            // loadingMessage={() => 'searching...'}   //minor type-O here
                                                            menuPortalTarget={document.body}
                                                            name="namffe"
                                                        /><br />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <label className="form-label">Bank Account#.</label>
                                                    </div>
                                                    <div className="col-md-10">
                                                        <input id="input" type="text" className="form-control"
                                                            name="bank_account_no" placeholder='Bank Account No.'
                                                            value={this.state.bank_account_no} onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12"><br />
                                            <Button type="submit" color="primary" outline className="btn-paypal btn-lg float-right" >
                                                {this.state.isLoading ? "Please Wait..." : "Save"}

                                            </Button> &nbsp;&nbsp;&nbsp;
                                    </div>



                                    </form>
                                </CardBody>
                            </Card>
                        </Col >
                    </>
                )
                }
            </div>
        )
    }
}
export default withTranslation('common')(ModifyAgent);
